
import { Fragment, useState } from "react";
import _ from "lodash";

import AdminProductProcess from "./AdminProductProcess";
import productApi from "../../api/productApi";
import variableApi from "../../api/variableApi";
import { dataValidator } from "../../tools/dataValidator";
import useMount from '../../hooks/useMount';
import { getLabel, getLanguage } from "../../tools/Dictionary";
import AlertModal from "../Commons/AlertModal";
import ConfirmModal from "../Commons/ConfirmModal";
import LoadingComponent from "../Commons/LoadingComponent";
import LabelInput from "../Commons/LabelInput";
import TagInput from "../Commons/TagInput";
import ProductFileSelector from "../ProductFile/ProductFileSelector";
import ProductFileDisplay from "../ProductFile/ProductFileDisplay";
import ActionButton from "../Commons/ActionButton";
import AdminProductDupFileModal from "./AdminProductDupFileModal";

import { MdMode, MdOutlineRemoveRedEye, MdNoteAdd, MdOutlineExpandLess, MdOutlineExpandMore, MdContentCopy, MdOutput   } from "react-icons/md";
import { BiUnlink } from "react-icons/bi";

const AdminProductModal = (props) => {

  //Props
  const IsDesktop = props.IsDesktop;
  const Access = props.Access;
  const Id = props.Id;
  const ProductFamily = props.ProductFamily;
  const ProductType = props.ProductType;
  const ProductCategory = props.ProductCategory;
  const Brand = props.Brand;
  const OnCloseModal = props.OnCloseModal;
  //const ProductType = props.ProductType;
  const LoadData = props.LoadData;
  const OnDuplicate = props.OnDuplicate;
  const Duplicate = props.Duplicate;
  
  //State
  const [form, setForm] = useState(undefined);
  const [error, setError] = useState({});
  const [loading, setLoading] = useState(true);
  const [modalProcess, setModalProcess] = useState({
    display: false,
    id: 0
  });
  const [modalDuplicateFile, setModalDuplicateFile] = useState(false);
  const [modalFile, setModalFile] = useState({
    display: false,
    index: -1
  });
  const [productCategory, setProductCategory] = useState([]);
  const [productType, setProductType] = useState([]);
  const [productFamily, setProductFamily] = useState([]);
  const [isUpdate, setIsUpdate] = useState(Id && Id != 0);
  const [alert, setAlert] = useState({
    Title: "",
    Message: "",
    Confirm: "",
    onConfirm: () => void 0,
    Display: false
  });
  const [confirm, setConfirm] = useState({
    Title: "",
    Message: "",
    Cancel: "",
    onCancel: () => void 0,
    Confirm: "",
    onConfirm: () => void 0,
    Display: false
  });
  const [oriFile, setOriFile] = useState([]);

  //Variables
  const baseForm = {
    _id: 0,
    code: "",
    label: {},
    process: undefined,
    processVariable: [],
    isTemplate: true,
    tag: [],
    virtualAssistant: "",
    productFile: [],
    isActive: true
  }


  useMount(() =>
  {
    loadData();
  }, []);


  const loadData = async() => {


    if (isUpdate){


      try{

        setLoading(true);

        let response = await productApi.getProduct(Id);

        if (!response.Success)
        {

          let error = new Error()
          error.message = response.Error && response.Error.component ? getLabel(response.Error.component, response.Error.label) : undefined;

          throw error;

        }


        setForm({
          _id: response.Data._id,
          code: response.Data.code,
          label: response.Data.label,
          brand: response.Data.brand ? response.Data.brand._id : undefined,
          productCategory: response.Data.productCategory ? response.Data.productCategory._id : undefined,
          productType: response.Data.productType ? response.Data.productType._id : undefined,
          productFamily: response.Data.productFamily ? response.Data.productFamily._id : undefined,
          process: response.Data.process,
          processVariable: response.Data.processVariable,
          tag: response.Data.tag || [],
          virtualAssistant: response.Data.virtualAssistant || "",
          productFile: response.Data.productFile || [],
          isActive: response.Data.isActive,
          isTemplate: response.Data.isTemplate 
        });

        setProductCategory(ProductCategory);
        setProductType(ProductType);
        setProductFamily(ProductFamily);
      
        setOriFile(response.Data.productFile || []);

        setLoading(false);

      }catch(err){


        setAlert({
          Title: getLabel("App", "Error"),
          Message: err.message || getLabel("App", "Sorry, an unknown error has occurred. Please try again later or contact our support team for assistance."),
          Confirm: getLabel("App", "Ok"),
          onConfirm: onFatalError,
          Display: true
        });

      }

    }else{
      //Add
      setForm(Duplicate || baseForm);

      setProductCategory(ProductCategory);
      setProductType(ProductType);
      setProductFamily(ProductFamily);

      setLoading(false);
    }

  };

  const onFatalError = async() => {

    setAlert(alert => ({ ...alert, Display: false }));

    await LoadData();

    setLoading(false);

    OnCloseModal();

  };

  const onChangeCode = (e) => {

    let code = e.target.value;

    if (code.length > 100) return; //Check length

    onValidateField("code", code); //Validate field value

    setForm(form => ({
      ...form,
      code
    }));
  };

  const onChangeLabel = (_value, _field) =>
  {

    onValidateField("label", _value); //Validate field value

    setForm(form => ({
      ...form,
      label: _value
    }));


  };


  const onChangeBrand = (e) => {

    if (loading) return;

    let brand = e.target.value;

    let tempForm = _.cloneDeep(form);


    tempForm.brand = brand;

    onValidateField("brand", brand);

    setForm(tempForm);


  };

  const onChangeProductCategory = (e) =>
  {

    let productCategory = e.target.value;

    let tempForm = _.cloneDeep(form);

    // if (!productCategory || productCategory != form.productCategory)
    // {
    //   tempForm.productType = "";
    //   tempForm.productFamily = "";
    // }

    // if (productCategory && productCategory != form.productCategory)
    // {

    //   setProductType(ProductType.filter(typ =>
    //   {

    //     if (typ.hierarchy.some(h => h.brand == tempForm.brand && h.category == productCategory)) return true;

    //     return false;
    //   }));

    // }

    tempForm.productCategory = productCategory;

    onValidateField("productCategory", productCategory);

    setForm(tempForm);


  };

  const onChangeProductType = (e) =>
  {

    let productType = e.target.value;

    let tempForm = _.cloneDeep(form);

    // if (!productType || productType != form.productType)
    // {
    //   tempForm.productFamily = "";
    // }

    // if (productType && productType != form.productType)
    // {


    //   setProductFamily(ProductFamily.filter(fam =>
    //   {
    //     if (fam.hierarchy.some(h => h.brand == tempForm.brand && h.category == tempForm.productCategory && h.type == productType)) return true;

    //     return false;
    //   }));

    // }

    tempForm.productType = productType;

    onValidateField("productType", productType);

    setForm(tempForm);

  };

  const onChangeProductFamily = (e) =>
  {

    let productFamily = e.target.value;

    onValidateField("productFamily", productFamily);

    setForm(form => ({
      ...form,
      productFamily
    }));
  };


  const onChangeProcess = async(_process) => {


    try
    {

      setLoading(true);

      let variableData = await variableApi.getVariables({ filter: "process eq " + _process._id + " and isParameter is true", select: `_id,name,description,variableTypeCode,data,order`, translate: getLanguage().code, sort: "order asc" });

      if (!variableData.Success)
      {

        let error = new Error()
        error.message = variableData.Error && variableData.Error.component ? getLabel(variableData.Error.component, variableData.Error.label) : undefined;

        throw error;

      }

      let processVariable = variableData.Data.map(v => 
        ({
          variable: {
            _id: v._id,
            name: v.name,
            description: v.description,
            variableTypeCode: v.variableTypeCode
          },
          data: v.data,
          order: v.order
        }) 
      );


      setForm(form => ({
        ...form,
        process: {
          _id: _process._id,
          code: _process.code
        },
        processVariable: processVariable
      }));



      setLoading(false);

    } catch (err)
    {


      setAlert({
        Title: getLabel("App", "Error"),
        Message: err.message || getLabel("App", "Sorry, an unknown error has occurred. Please try again later or contact our support team for assistance."),
        Confirm: getLabel("App", "Ok"),
        onConfirm: onFatalError,
        Display: true
      });

    }



  }

  const onChangeParameter = (e, _data) => {

    try{

      let currentform = _.cloneDeep(form);

      const currentIndex = currentform.processVariable.findIndex(p => p.variable._id == _data.variable._id);

      currentform.processVariable[currentIndex].data = e.target.value;

      onValidateField("parameter", currentform.processVariable[currentIndex]);

      setForm(currentform);

    }catch(err){

      setAlert({
        Title: getLabel("App", "Error"),
        Message: err.message || getLabel("App", "Sorry, an unknown error has occurred. Please try again later or contact our support team for assistance."),
        Confirm: getLabel("App", "Ok"),
        onConfirm: onFatalError,
        Display: true
      });

    }




  };

  const onChangeTag = (_tag) =>
  {

    setForm(form => ({
      ...form,
      tag: _tag
    }));

  };

  const onChangeVirtual = (e) => {


    let virtualAssistant = e.target.value;

    if (virtualAssistant && virtualAssistant.length > 4000) return; //Check length

    onValidateField("virtualAssistant", virtualAssistant); //Validate field value

    setForm(form => ({
      ...form,
      virtualAssistant
    }));

  };

  const onChangeActif = () => {

    setForm(form => ({
      ...form,
      isActive: !form.isActive
    }));

  };

  const onClickRemoveProcess = () =>
  {

    setConfirm(confirm => ({
      Title: getLabel("App", "Delete"),
      Message: getLabel("AdminProduct", "Would you like to remove this troubleshooting process from this product?"),
      Cancel: getLabel("App", "No"),
      onCancel: () => setConfirm(confirm => ({ ...confirm, Display: false })),
      Confirm: getLabel("App", "Yes"),
      onConfirm: onRemoveProcess,
      Display: true
    }));

  };

  const onRemoveProcess = () => {

    setConfirm(confirm => ({ ...confirm, Display: false }))


    setForm(form => ({
      ...form,
      process: undefined,
      processVariable: []
    }));    

  };

  const onSelectFile = (_file) => {

    setForm(form => ({
      ...form,
      productFile: [...form.productFile, {
        _id: _file._id,
        name: _file.name,
        label: _file.label,
        type: _file.type,
        format: _file.format
      }]
    }));

    setModalFile({ display: false, index: -1 });

  };

  const onClickRemoveFile = (_index) =>
  {

    setConfirm(confirm => ({
      Title: getLabel("App", "Delete"),
      Message: getLabel("AdminProduct", "Would you like to remove this file from this product?"),
      Cancel: getLabel("App", "No"),
      onCancel: () => setConfirm(confirm => ({ ...confirm, Display: false })),
      Confirm: getLabel("App", "Yes"),
      onConfirm: () => onRemoveFile(_index),
      Display: true
    }));

  };

  const onRemoveFile = (_index) =>
  {

    setConfirm(confirm => ({ ...confirm, Display: false }))


    setForm(form => ({
      ...form,
      productFile: form.productFile.filter((_, index) => index !== _index)
    }));

  };

  const onClickMoveFile = (_move, _index) =>
    {
  
  
      try
      {
  
       if (!form.productFile[_index + _move]) return;
  
  
        let toUpdateFile = _.cloneDeep(form.productFile);
  
        const [toMoveFile] = toUpdateFile.splice(_index, 1);
        toUpdateFile.splice(_index + _move, 0, toMoveFile);  
  
        setForm(form => ({
          ...form,
          productFile: toUpdateFile
        }));
  
      } catch (err)
      {
  
        setAlert({
          Title: getLabel("App", "Error"),
          Message: err.message || getLabel("App", "Sorry, an unknown error has occurred. Please try again later or contact our support team for assistance."),
          Confirm: getLabel("App", "Ok"),
          onConfirm: () => setAlert(alert => ({ ...alert, Display: false })),
          Display: true
        });
  
      }
  
    };


  // Validate field
  const onValidateField = (field = "", value = "") =>
  {
    let currentError = { ...error }; // Create a copy of the error object

    let Validation = []; // Array to store validation results
    let currentValidation = [];
    let currentField = "";

    let isValid = true; // Flag to track overall validity

    currentField = "code";
    if (field == "" || field == currentField)
    {
      let currentValue = field ? value : form[currentField];

      // Validate
      currentValidation = dataValidator([
        { field: currentField, value: currentValue, listValidation: ["required", "max:100"] }
      ]);

      Validation = [...Validation, ...currentValidation];

    }
    
    currentField = "label";
    if (field == "" || field == currentField)
    {
      let currentValue = field ? value : form[currentField];

      // Validate
      currentValidation = dataValidator([
        { field: currentField, value: currentValue, listValidation: ["required", "label"] }
      ]);

      Validation = [...Validation, ...currentValidation];

    }

    currentField = "brand";
    if (field == "" || field == currentField)
    {
      let currentValue = field ? value : form[currentField];

      // Validate
      currentValidation = dataValidator([
        { field: currentField, value: currentValue, listValidation: ["required"] }
      ]);

      Validation = [...Validation, ...currentValidation];

    }

    currentField = "productCategory";
    if (field == "" || field == currentField)
    {
      let currentValue = field ? value : form[currentField];

      // Validate
      currentValidation = dataValidator([
        { field: currentField, value: currentValue, listValidation: ["required"] }
      ]);

      Validation = [...Validation, ...currentValidation];

    }

    currentField = "productType";
    if (field == "" || field == currentField)
    {
      let currentValue = field ? value : form[currentField];

      // Validate
      currentValidation = dataValidator([
        { field: currentField, value: currentValue, listValidation: ["required"] }
      ]);

      Validation = [...Validation, ...currentValidation];

    }

    currentField = "productFamily";
    if (field == "" || field == currentField)
    {
      let currentValue = field ? value : form[currentField];

      // Validate
      currentValidation = dataValidator([
        { field: currentField, value: currentValue, listValidation: ["required"] }
      ]);

      Validation = [...Validation, ...currentValidation];

    }

    currentField = "virtualAssistant";
    if (field == "" || field == currentField)
    {
      let currentValue = field ? value : form[currentField];


      // Validate
      currentValidation = dataValidator([
        { field: currentField, value: currentValue, listValidation: ["max:4000"] }
      ]);

      Validation = [...Validation, ...currentValidation];

    }

    if (field == "parameter"){

      let listValidation = ["max:100"];

      switch (value.variable.variableTypeCode) {
        case "int":
          listValidation.push("integer");
          break;
        case "number":
          listValidation.push("number");
          break;    
        default:
          break;
      }



      // Validate
      currentValidation = dataValidator([
        { field: "parameter_" + value.variable._id, value: value.data, listValidation: listValidation }
      ]);

      Validation = [...Validation, ...currentValidation];

    }

    if (field == ""){

      form.processVariable.forEach(v => {

        let listValidation = ["max:100"];

        switch (v.variable.variableTypeCode)
        {
          case "int":
            listValidation.push("integer");
            break;
          case "number":
            listValidation.push("number");
            break;
          default:
            break;
        }

        // Validate
        currentValidation = dataValidator([
          { field: currentField + "_" + v.variable.id, value: v.data, listValidation: listValidation }
        ]);

        Validation = [...Validation, ...currentValidation];


        
      });

    }

    

    // currentField = "productType"
    // if (field == "" || field == currentField)
    // {
    //   let currentValue = field ? value : form[currentField];

    //   // Validate
    //   currentValidation = dataValidator([
    //     { field: currentField, value: currentValue, listValidation: ["required"] }
    //   ]);

    //   Validation = [...Validation, ...currentValidation];
    // }

    Validation.forEach(validation =>
    {
      // Iterate over each validation result
      if (validation.valid)
      {
        currentError[validation.field] = ""; // If valid, clear the corresponding error field
      } else
      {
        currentError[validation.field] = validation.reason; // If invalid, set the error reason in the corresponding field
        isValid = false; // Set isValid to false if any validation fails
      }
    });

    setError(currentError); // Update the error state

    return isValid; // Return the overall validity flag
  };


  const onClickDelete = () => {

    setConfirm(confirm => ({
      Title: getLabel("App", "Delete"),
      Message: getLabel("AdminProduct", "Are you certain you wish to proceed..."),
      Cancel: getLabel("App", "No"),
      onCancel: () => setConfirm(confirm => ({ ...confirm, Display: false })),
      Confirm: getLabel("App", "Yes"),
      onConfirm: onDelete,
      Display: true
    }));

  };

  const onDelete = async() => {

    try
    {

      setConfirm(confirm => ({ ...confirm, Display: false }))

      setLoading(true);

      let response = await productApi.deleteProduct(Id);

      if (!response.Success)
      {

        let error = new Error("");
        error.message = response.Error && response.Error.component ? getLabel(response.Error.component, response.Error.label) : undefined;

        throw error;

      }

      await LoadData();

      OnCloseModal();



    } catch (err)
    {
      await LoadData();

      setLoading(false);

      setAlert({
        Title: getLabel("App", "Error"),
        Message: err.message || getLabel("App", "Sorry, an unknown error has occurred. Please try again later or contact our support team for assistance."),
        Confirm: getLabel("App", "Ok"),
        onConfirm: OnCloseModal,
        Display: true
      });

    };   

  }

  const onClickSave = async() => {

    if (!onValidateField()){

      return;
    }

    try{

      await onSave();

      await LoadData();

      OnCloseModal();


    }catch(err){

      setLoading(false);

    }


  }

  const onSave = async() => {

    try{

      setLoading(true);

      let parameters = {
        _id: form._id || 0,
        code: form.code,
        label: form.label,
        brand: form.brand,
        productCategory: form.productCategory,
        productType: form.productType,
        productFamily: form.productFamily,
        process: form.process ? form.process._id : null,
        processVariable: form.processVariable.map(v => ({
          variable: v.variable._id,
          data: v.data,
          order: v.order
        })),
        tag: form.tag,
        virtualAssistant: form.virtualAssistant,
        productFile: form.productFile,
        isActive: form.isActive
      }

      let response = await productApi.updateProduct(parameters);

      if (!response.Success){

        let error = new Error()
        error.message = response.Error && response.Error.component ? getLabel(response.Error.component, response.Error.label) : undefined;

        throw error;

      }

      return response.Data;


    }catch(err){

      setLoading(false);

      setAlert({
        Title: getLabel("App", "Error"),
        Message: err.message || getLabel("App", "Sorry, an unknown error has occurred. Please try again later or contact our support team for assistance."),
        Confirm: getLabel("App", "Ok"),
        onConfirm: () => setAlert(alert => ({ ...alert, Display: false })),
        Display: true
      });

      throw err;

    };

  };

  const onClickDuplicate = async() => {

    setIsUpdate(false);

    await OnDuplicate({
      ...form,
      _id: 0
    });

    await setForm({
      ...form,
      _id: 0
    });

    document.getElementById('input_code').focus();
  };

  const onClickDuplicateFile = () => {

    if (form.productFile == oriFile){
      setModalDuplicateFile(true);
    }else{
      
      setConfirm(confirm => ({
        Title: getLabel("App", "Warning"),
        Message: getLabel("AdminProduct", "The product files have been modified and must be saved before duplicating. Please save your changes to continue."),
        Cancel: getLabel("App", "No"),
        onCancel: () => setConfirm(confirm => ({ ...confirm, Display: false })),
        Confirm: getLabel("App", "Yes"),
        onConfirm: () => {
          proceedWithSaveThenDuplicate();
        },
        Display: true
      }));

    }

    
  };

  const proceedWithSaveThenDuplicate= async() => { 

    setConfirm(confirm => ({ ...confirm, Display: false }));

    try{

      if (!isUpdate) {
        onClickSave();
        return;
      }

      if (!onValidateField()){

        return;
      }

      setLoading(true);

      await onSave();

      await LoadData();

      await loadData();

      setModalDuplicateFile(true);


    }catch(err){  
      setAlert({
        Title: getLabel("App", "Error"),
        Message: err.message || getLabel("App", "Sorry, an unknown error has occurred. Please try again later or contact our support team for assistance."),
        Confirm: getLabel("App", "Ok"),
        onConfirm: () => setAlert(alert => ({ ...alert, Display: false })),
        Display: true
      });
      setLoading(false);

    }

  }


  const onSaveDuplicateFile = async(_selected) => {
  
    try{

      let parameters = {
        _id: form._id,
        selectedProduct: _selected.map(s => s._id)
      }

      let response = await productApi.duplicateProductFile(parameters);

      if (!response.Success){

        let error = new Error()
        error.message = response.Error && response.Error.component ? getLabel(response.Error.component, response.Error.label) : undefined;

        throw error;

      }

      setModalDuplicateFile(false);


    }catch(err){

      setAlert({
        Title: getLabel("App", "Error"),
        Message: err.message || getLabel("App", "Sorry, an unknown error has occurred. Please try again later or contact our support team for assistance."),
        Confirm: getLabel("App", "Ok"),
        onConfirm: () => setAlert(alert => ({ ...alert, Display: false })),
        Display: true
      });

    }

   



  
  }


  if (!form) return (
    <div className="page_modal_background">
      <div className="page_modal_cont" style={{ width: "900px" }}>
        <LoadingComponent
          display={loading}
          label={getLabel("App", "Loading")}
        />
        <AlertModal
          Title={alert.Title}
          Message={alert.Message}
          Confirm={alert.Confirm}
          onConfirm={alert.onConfirm}
          Display={alert.Display}
        />
        <div className="page_modal_header_cont" style={{ marginBottom: "10px" }}>
          {getLabel("AdminProduct", "Product")}
        </div>
        <div className="page_modal_body_cont" />
        <div className="page_modal_footer_cont">
          <input
            type="button"
            className="page_button page_modal_footer_button"
            value={getLabel("App", "Close")}
            style={{ backgroundColor: "grey", maxWidth: "200px" }}
            onClick={OnCloseModal}
            disabled={loading}
          />
        </div>
      </div>
    </div>
  );
  

  return (
    <div className="page_modal_background">
      <div className="page_modal_cont" style={{ width: "900px" }}>
        {(modalDuplicateFile && Access.canWrite == true) &&
          <AdminProductDupFileModal
            IsDesktop={IsDesktop}
            Access={Access}
            OnCloseModal={() => setModalDuplicateFile(false)}
            OnSave={onSaveDuplicateFile}
            Id={form._id}
          />
        }
        {modalProcess.display &&
          <AdminProductProcess
            IsDesktop={IsDesktop}
            Access={Access}
            Id={modalProcess.id}
            onSelect={onChangeProcess}
            OnCloseModal={() => setModalProcess({display: false, id: 0})}
            OnChangeProcess={onChangeProcess}
          />
        }

        {modalFile.display && 
          <ProductFileSelector
            IsDesktop={IsDesktop}
            Access={Access}
            OnSelectFile={onSelectFile}
            OnCloseModal={() => setModalFile({ display: false, index: -1 })}
          />
        }

        <LoadingComponent
          display={loading}
          label={getLabel("App", "Loading")}
          isCover={true}
        />
        <AlertModal
          Title={alert.Title}
          Message={alert.Message}
          Confirm={alert.Confirm}
          onConfirm={alert.onConfirm}
          Display={alert.Display}
        />
        <ConfirmModal
          Display={confirm.Display}
          Title={confirm.Title}
          Message={confirm.Message}
          Cancel={confirm.Cancel}
          onCancel={confirm.onCancel}
          Confirm={confirm.Confirm}
          onConfirm={confirm.onConfirm}
        />
        <div className="page_modal_header_cont" style={{ marginBottom: (Access.canWrite == true && isUpdate == true) ? "0px" : "10px" }}>
          {getLabel("AdminProduct", "Product")} {Duplicate ? `(${getLabel("VariableDesignerModal", "Duplicate")})`:``}
        </div>
        {(Access.canWrite == true && isUpdate == true) &&
          <div className="page_modal_header_action_cont" style={{ minHeight: "40px" }}>
            <ActionButton
              IsDesktop={IsDesktop}
              Label={getLabel("VariableDesignerModal", "Duplicate")}
              Icon={MdContentCopy}
              Disabled={loading}
              OnClick={onClickDuplicate}
              buttonStyle={{ fontSize: "80%", marginRight: "10px" }}
            />
          </div>
        }
        <div className="page_modal_body_cont">
          <div className="page_modal_body_row">
            <div className="page_modal_body_col_title">
              {getLabel("T_Product", "code")}
            </div>
            <div className="page_modal_body_col_value" style={{ width: "400px" }} >
              <input
                className={"page_text_input " + (error["code"] ? "page_modal_body_col_input_error" : "")}
                value={form.code || ""}
                onChange={onChangeCode}
                type="text"
                style={{ width: "100%" }}
                disabled={!Access.canWrite || loading}
                id="input_code"
              />
              {error["code"] &&
                <div className="page_modal_body_col_extra page_modal_body_col_error">
                  {error["code"]}
                </div>
              }
            </div>
          </div>
          <div className="page_modal_body_row">
            <div className="page_modal_body_col_title">
                {getLabel("T_Product", "label")}
            </div>
            <div className="page_modal_body_col_value" style={{ width: "600px" }} >
              <LabelInput
                ReadOnly={!Access.canWrite}
                Data={form.label}
                ListValidation={["max:1000"]}
                TextStyle={{ height: "100px" }}
                PreviewMaxLength={400}
                Property={"label"}
                OnChangeValue={onChangeLabel}
                Autofill={{
                  value: form.code,
                  property: getLabel("T_Product", "code")
                }}
              />
              {error["label"] &&
                <div className="page_modal_body_col_extra page_modal_body_col_error">
                  {error["label"]}
                </div>
              }
            </div>
          </div>
          <div className="page_modal_body_row">
            <div className="page_modal_body_col_title">
              {getLabel("T_Product", "brand")}
            </div>
            <div className="page_modal_body_col_value" style={{ width: "300px" }} >
              <select
                value={form.brand}
                className={"page_select_input " + (error["brand"] ? "auth_fill_row_input_error " : "")}
                onChange={onChangeBrand}
                style={{ width: "300px", textAlign: "center", color: "black"}}
                disabled={!Access.canWrite || loading}
              >
                <option value="" hidden style={{ textAlign: "center" }}></option>
                {Brand.map((o, index) => (
                  <option key={index} value={o._id} style={{ textAlign: "center", color: "black" }}>
                    {o.code}
                  </option>
                ))}
              </select>
              {error["brand"] &&
                <div className="page_modal_body_col_extra page_modal_body_col_error">
                  {error["brand"]}
                </div>
              }
            </div>
          </div>
          <div className="page_modal_body_row">
            <div className="page_modal_body_col_title">
              {getLabel("T_Product", "productCategory")}
            </div>
            <div className="page_modal_body_col_value" style={{ width: "300px" }} >
              <select
                value={form.productCategory}
                className={"page_select_input " + (error["productCategory"] ? "auth_fill_row_input_error " : "")}
                onChange={onChangeProductCategory}
                style={{ width: "300px", textAlign: "center", color: "black" }}
                disabled={!Access.canWrite || loading}
              >
                <option value="" hidden style={{ textAlign: "center" }}></option>
                {productCategory.map((o, index) => (
                  <option key={index} value={o._id} style={{ textAlign: "center", color: "black" }}>
                    {o.code}
                  </option>
                ))}
              </select>
              {error["productCategory"] &&
                <div className="page_modal_body_col_extra page_modal_body_col_error">
                  {error["productCategory"]}
                </div>
              }
            </div>
          </div>
          <div className="page_modal_body_row">
            <div className="page_modal_body_col_title">
              {getLabel("T_Product", "productType")}
            </div>
            <div className="page_modal_body_col_value" style={{ width: "300px" }} >
              <select
                value={form.productType}
                className={"page_select_input " + (error["productType"] ? "auth_fill_row_input_error " : "")}
                onChange={onChangeProductType}
                style={{ width: "300px", textAlign: "center", color: "black" }}
                disabled={!Access.canWrite || loading}
              >
                <option value="" hidden style={{ textAlign: "center" }}></option>
                {productType.map((o, index) => (
                  <option key={index} value={o._id} style={{ textAlign: "center", color: "black" }}>
                    {o.code}
                  </option>
                ))}
              </select>
              {error["productType"] &&
                <div className="page_modal_body_col_extra page_modal_body_col_error">
                  {error["productType"]}
                </div>
              }
            </div>
          </div>
          <div className="page_modal_body_row">
            <div className="page_modal_body_col_title">
              {getLabel("T_Product", "productFamily")}
            </div>
            <div className="page_modal_body_col_value" style={{ width: "300px" }} >
              <select
                value={form.productFamily}
                className={"page_select_input " + (error["productFamily"] ? "auth_fill_row_input_error " : "")}
                onChange={onChangeProductFamily}
                style={{ width: "300px", textAlign: "center", color: "black" }}
                disabled={!Access.canWrite || loading}
              >
                <option value="" hidden style={{ textAlign: "center" }}></option>
                {productFamily.map((o, index) => (
                  <option key={index} value={o._id} style={{ textAlign: "center", color: "black" }}>
                    {o.code}
                  </option>
                ))}
              </select>
              {error["productFamily"] &&
                <div className="page_modal_body_col_extra page_modal_body_col_error">
                  {error["productFamily"]}
                </div>
              }
            </div>
          </div>
          <div className="page_modal_body_row">
            <div className="page_modal_body_col_title">
              {getLabel("T_Product", "tags")}
            </div>
            <div className="page_modal_body_col_value" style={{ width: "400px" }} >
              <TagInput
                ReadOnly={!Access.canWrite}
                Tag={form.tag}
                OnChangeValue={onChangeTag}
              />
            </div>
          </div>
          <div className="page_modal_body_row">
            <div className="page_modal_body_col_title">
              {getLabel("T_Product", "Virtual assistant")}
            </div>
            <div className="page_modal_body_col_value" style={{ width: "400px" }} >
              <textarea
                className={"page_textarea_input " + (error["virtualAssistant"] ? "page_modal_body_col_input_error" : "")}
                rows={3}
                value={form.virtualAssistant || ""}
                onChange={onChangeVirtual}
                type="text"
                placeholder={getLabel("T_Product", "To assist the virtual assistant in troubleshooting, please provide detailed information, such as similar products.")}
                style={{ width: "100%" }}
                disabled={!Access.canWrite || loading}
              />
              {error["virtualAssistant"] &&
                <div className="page_modal_body_col_extra page_modal_body_col_error">
                  {error["virtualAssistant"]}
                </div>
              }
            </div>
          </div>
          <div className="page_modal_body_row">
            <div className="page_modal_body_col_title">
              {getLabel("AdminProduct", "Troubleshooting Process")}
            </div>
            <div className="page_modal_body_col_value" style={{ width: "600px" }} >
              <input
                id="processInput"
                className={"page_text_input"}
                value={form.process && form.process.code ? form.process.code : ""}
                type="text"
                style={{ width: "100%", marginBottom: "5px"}}
                disabled={true}
              />
              <div className="adminproduct_row">
                {Access.canWrite &&
                  < div className="page_button"
                    style={{ width: "180px", height: "30px", fontSize: "20px", marginRight: "5px" }}
                    title={getLabel("AdminProduct", "Select")}
                    onClick={() => setModalProcess({ display: true, id: 0 })}
                      >
                    <div className="labelinput_preview_col" style={{ width: "30%" }}>
                      <MdMode />
                    </div>
                    <div className="labelinput_preview_col" style={{ width: "70%" }}>
                      {getLabel("AdminProduct", "Select")}
                    </div>
                  </div>
                }
                {(form.process && form.process._id) && 
                  < div className="page_button"
                    style={{ width: "180px", height: "30px", fontSize: "20px", marginRight: "5px" }}
                    title={getLabel("AdminProduct", "Display")}
                    onClick={() => setModalProcess({ display: true, id: form.process._id })}
                  >
                    <div className="labelinput_preview_col" style={{ width: "30%" }}>
                      <MdOutlineRemoveRedEye /> 
                    </div>
                    <div className="labelinput_preview_col" style={{ width: "70%" }}>
                      {getLabel("AdminProduct", "Display")}
                    </div>
                  </div>
                }
                {Access.canWrite && form.process && 
                  <div className="page_button"
                    style={{ width: "40px", height: "30px", fontSize: "26px", marginRight: "5px", backgroundColor: "#b30000" }}
                    title={getLabel("App", "Remove")}
                    onClick={onClickRemoveProcess}
                    >
                    <BiUnlink />
                  </div>
                }
              </div>
            </div>
          </div>
          {form.process && form.processVariable && form.processVariable.length > 0 &&
            <div className="adminproduct_modal_section_cont">
              <div className="page_modal_body_row_center_title">
                {getLabel("AdminProduct", "Process parameters")}
              </div>
              {form.processVariable.map((v, index) => (
                <div className="page_modal_body_row" key={index}>
                  <div className="page_modal_body_col_title">
                    {v.variable.name}
                  </div>
                  <div className="page_modal_body_col_value" style={{ width: "400px" }} >
                    <input
                      className={"page_text_input " + (error["parameter_" + v.variable._id] ? "page_modal_body_col_input_error" : "")}
                      value={v.data || ""}
                      onChange={(e) => onChangeParameter(e, v)}
                      type="text"
                      style={{ width: "100%" }}
                      disabled={!Access.canWrite || loading}
                    />
                    <div>
                      {v.variable.description}
                    </div>
                    {error["parameter_" + v.variable._id] &&
                      <div className="page_modal_body_col_extra page_modal_body_col_error">
                        {error["parameter_" + v.variable._id]}
                      </div>
                    }
                  </div>
                </div>
              ))}
            </div>
          }
          <div className="page_modal_body_row" style={{marginTop: "10px"}}>
            <div className="page_modal_body_col_title">
              {getLabel("T_Product", "productFile")}
            </div>
            <div className="adminproduct_value_group" >
              {(Access.canWrite && form.productFile.length > 0) &&
                <ActionButton
                  IsDesktop={IsDesktop}
                  Label={getLabel("AdminProduct", "Duplicate to")}
                  Icon={MdOutput}
                  Disabled={loading}
                  OnClick={onClickDuplicateFile}
                  buttonStyle={{ fontSize: "80%", marginRight: "10px" }}
                />
              }
              {form.productFile.map((f, indexF) => (
                <div className="adminproduct_row" style={{width: IsDesktop ? "600px" : "100%", marginBottom: "5px" }} key={indexF} >
                  {Access.canWrite &&
                    <div className="page_button"
                      style={{ width: "40px", height: "30px", fontSize: "26px", marginRight: "5px", backgroundColor: "#424749" }}
                      title={getLabel("App", "Remove")}
                      onClick={() => onClickMoveFile(-1, indexF)}
                    >
                      <MdOutlineExpandLess />
                    </div>
                  }
                  {Access.canWrite && 
                    <div className="page_button"
                      style={{ width: "40px", height: "30px", fontSize: "26px", marginRight: "5px", backgroundColor: "#424749" }}
                      title={getLabel("App", "Remove")}
                      onClick={() => onClickMoveFile(1, indexF)}
                    >
                      <MdOutlineExpandMore />
                    </div>
                  }
                  {Access.canWrite &&
                    <div className="page_button"
                      style={{ width: "40px", height: "30px", fontSize: "26px", marginRight: "5px", backgroundColor: "#b30000" }}
                      title={getLabel("App", "Remove")}
                      onClick={() => onClickRemoveFile(indexF)}
                    >
                      <BiUnlink />
                    </div>
                  }
                  <ProductFileDisplay
                    Data={f}
                    Style={{justifyContent: "flex-start"}}
                  />
                </div>
              ))}
              <div className="page_modal_body_col_value" style={{ width: "300px", paddingLeft: "0px" }} >
                {Access.canWrite &&
                  < div className="page_button"
                    style={{ width: "180px", height: "30px", fontSize: "20px", marginRight: "5px" }}
                    title={getLabel("AdminProduct", "Add file")}
                    onClick={() => setModalFile({ display: true, index: -1 })}
                  >
                    <div className="labelinput_preview_col" style={{ width: "30%" }}>
                      <MdNoteAdd />
                    </div>
                    <div className="labelinput_preview_col" style={{ width: "70%" }}>
                      {getLabel("AdminProduct", "Add file")}
                    </div>
                  </div>
                }              
              </div>
            </div>
          </div>
          <div className="page_modal_body_row">
            <div className="page_modal_body_col_title">
              {getLabel("T_Product", "isActive")}
            </div>
            <div className="page_modal_body_col_value" style={{ width: "300px" }} >
              <label className="page_switch">
                <input
                  type="checkbox"
                  checked={form.isActive}
                  onChange={onChangeActif}
                  disabled={!Access.canWrite || loading}
                />
                <span className="page_slider round" />
              </label>
            </div>
          </div>
        </div>
        <div className="page_modal_footer_cont">
          <input
            type="button"
            className="page_button page_modal_footer_button"
            value={getLabel("App", "Close")}
            style={{ backgroundColor: "grey", maxWidth: "200px" }}
            onClick={(loading && !OnCloseModal) ? undefined : OnCloseModal}
            disabled={loading}
          />
          {!!Access.canWrite &&
            <Fragment>
            {isUpdate == true &&
                <input
                  type="button"
                  className="page_button page_modal_footer_button"
                  value={getLabel("App", "Delete")}
                  style={{ backgroundColor: "#b30000", maxWidth: "200px" }}
                  onClick={(loading && !OnCloseModal) ? undefined : onClickDelete}
                  disabled={loading}
                />
            }
            <input
              type="button"
              className="page_button page_modal_footer_button"
              value={getLabel("App","Save")}
              style={{ backgroundColor: "#52a3e7", maxWidth: "200px" }}
              onClick={(loading) ? undefined : onClickSave}
              disabled={loading}
            />
            </Fragment>
          }
        </div>
      </div>
    </div>
  );

};

export default AdminProductModal;